import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { NgIf, NgClass } from '@angular/common';
import { ProjectEngagementPageViewComponent } from '../project-engagement-page-view/project-engagement-page-view.component';
import { EngagementDetailsComponent } from '../../../../shared/components/engagement/engagement-details/engagement-details.component';
import { EngagementProComponent } from '../../../../shared/components/engagement/engagement-pro/engagement-pro.component';
import { EngagementLiteComponent } from '../../../../shared/components/engagement/engagement-lite/engagement-lite.component';
import { EngagementSummaryComponent } from '../../../../shared/components/engagement/engagement-summary/engagement-summary.component';
import {
  getShowComparisonFlag,
  setShowComparisonFlag,
} from '../../../../shared/utils/score-deviation.util';

@Component({
    selector: 'app-project-engagement-home',
    templateUrl: './project-engagement-home.component.html',
    styleUrls: ['./project-engagement-home.component.scss'],
    imports: [NgIf, NgClass, ProjectEngagementPageViewComponent, EngagementDetailsComponent, EngagementProComponent, EngagementLiteComponent, EngagementSummaryComponent]
})
export class ProjectEngagementHomeComponent implements OnInit {
  activeTab: string | null = null;

  tabList: any = []
  tabVisiblity: any = {
    lite: Helpers.isTabVisible(false, 'engagement', 'summary'),
    pro: Helpers.isTabVisible(false, 'engagement', 'summary_v2'),
    details: Helpers.isTabVisible(false, 'engagement', 'comparison_v2'),
    pageview: Helpers.isTabVisible(false, 'engagement', 'page_view_v2'),
    summary: Helpers.isTabVisible(false, 'engagement', 'summary') || Helpers.isTabVisible(false, 'engagement', 'summary_v2')
  }
  showRecordsJourney: boolean = false;
  showResponseDistribution: boolean = false;
  isDeviationEnabled = false;
  showDeviationToggle = false;

  constructor(private router: Router, private route: ActivatedRoute, private helpersService: HelpersService) {}

  ngOnInit() {

    this.tabVisiblity = {
      lite: Helpers.isTabVisible(false, 'engagement', 'summary'),
      pro: Helpers.isTabVisible(false, 'engagement', 'summary_v2'),
      details: Helpers.isTabVisible(false, 'engagement', 'comparison_v2'),
      pageview: Helpers.isTabVisible(false, 'engagement', 'page_view_v2'),
      summary: Helpers.isTabVisible(false, 'engagement', 'summary') || Helpers.isTabVisible(false, 'engagement', 'summary_v2')
    }
    
    if (this.tabVisiblity.lite)
      this.tabList.push('lite');

    if (this.tabVisiblity.pro)
      this.tabList.push('pro');

    if (this.tabVisiblity.details)
      this.tabList.push('details');

    if (this.tabVisiblity.pageview)
      this.tabList.push('pageview');

    if (this.tabVisiblity.summary)
      this.tabList.push('summary');

    let activeTab = (this.tabList && this.tabList.length) ? this.tabList[0] : '';
    // Initialize activeTab based on query parameters
    this.updateDeviationToggleVisibility(Helpers.datePicker);
    this.helpersService.datePicker.subscribe((datePicker: any) => {
      this.updateDeviationToggleVisibility(datePicker);
    });

    this.route.queryParams.subscribe(params => {
      let tabName = (this.tabList.indexOf(params['active_tab']) >= 0) ? params['active_tab'] : activeTab; // Default to 'lite' if no query param
      this.onClickingNavigation(tabName)

      // If the current tab is not in tabList, clear localStorage and reset variables
      if (!this.tabList.includes(params['active_tab'])) {
        localStorage.removeItem('showRecordsJourney');
        localStorage.removeItem('showResponseDistribution');
        localStorage.removeItem('showChannelPerformance');
        this.showRecordsJourney = false;
        this.showResponseDistribution = false;
      }
    });
  }

  onClickingNavigation(str: string) {
    this.activeTab = str;
    if (this.showDeviationToggle) {
      this.isDeviationEnabled = getShowComparisonFlag();
    }
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { active_tab: str },
      queryParamsHandling: 'merge'
    });
  }

  onDeviationToggle(event: Event) {
    if (this.showDeviationToggle) {
      this.isDeviationEnabled = (event.target as HTMLInputElement).checked;
      setShowComparisonFlag(this.isDeviationEnabled);
    }
  }

  private updateDeviationToggleVisibility(datePicker: any): void {
    this.showDeviationToggle = !!(datePicker?.isPresetActive && !datePicker?.isCustomDateRangeSelected);
    if (!this.showDeviationToggle) {
      this.isDeviationEnabled = false;
      setShowComparisonFlag(false);
    } else {
      this.isDeviationEnabled = getShowComparisonFlag();
    }
  }
}
